<template>
    <div :class="classes" class="heading">
        <div class="heading-wrapper">
            <div class="heading-title">
                <div class="visuallyhidden">
                    <slot name="page-title" />
                </div>
                <slot name="title" />
                <div v-if="hasTagsSlot" class="heading-tags">
                    <slot name="tag" />
                </div>
            </div>
            <div class="heading-spacer" />
            <div class="heading-buttons">
                <slot name="buttons" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'heading',
    props: {
        wrapButtons: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes () {
            return [
                { 
                    'wrap-buttons': this.wrapButtons
                }
            ]
        },
        hasTagsSlot () {
            return !!this.$slots['tag']
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.heading
    padding: 15px 40px
    margin: -40px -40px 20px -40px
    border-bottom: 1px solid $light-border-color

    .heading-wrapper
        display: flex
        width: 100%

        .heading-spacer
            flex-grow: 1

        .heading-title
            display: flex
            align-items: center
            justify-content: center

            h1, h2
                padding: 4px 0px 4px 0px
                margin: -1px 0px 0px 0px
                font-size: 30px
                line-height: 28px
                color: $text-dark-grey
                letter-spacing: 1px

        .heading-tags
            margin: 0px 10px

            > *
                margin-left: 10px

        .heading-buttons
            margin-top: 0px
            margin-bottom: 0px
            display: flex

            > *
                margin-left: 10px

            .app-button
                font-weight: bold

                &:hover
                    color: $white

    @media screen and (max-width: 1024px)
        margin: -40px -20px 20px -20px

    @media screen and (max-width: 480px)
        margin: 0px 0px 20px 0px
        padding: 15px 20px
        &.wrap-buttons
            .heading-wrapper
                display: block
                .heading-title
                    display: block
                    text-align: left
            .heading-buttons,
            .heading-tags
                margin: 10px 0 0
                display: block
                > *:first-child
                    margin-left: 0
</style>
